import { Grid } from '@sanlam-glacier/app-common/modules/grid';

type EmptyRowProps = {
  height?: number;
};

export const EmptyRow = ({ height }: EmptyRowProps) => {
  const styles: React.CSSProperties = height
    ? {
        height: `${height}px`
      }
    : {};
  return <Grid row style={styles} />;
};
